export const documentTypes = [
    {
        name: "Cédula",
        value: "CC"
    },
    {
        name: "NIT",
        value: "NIT"
    },
    {
        name: "Pasaporte",
        value: "PAP"
    },
    {
        name: "Cédula extranjería",
        value: "CE"
    }
];

export const clientTypes = [
    {
        name: "Persona Natural",
        value: "natural"
    },
    {
        name: "Persona Jurídica",
        value: "juridica"
    },
];